import React from 'react';

import { IVehicleSummaryBreakdowns } from 'common/types';
import { selectUserAvailableCredits } from 'modules/me/slice';
import { selectBookingPromo } from 'modules/transaction/slice';
import useAppSelector from 'hooks/useAppSelector';

interface Props {
  breakdowns: IVehicleSummaryBreakdowns | undefined;
  toggleUseCredits: boolean;
}

const SummaryInvoice = ({ breakdowns, toggleUseCredits }: Props) => {
  const bookingPromo = useAppSelector(selectBookingPromo);
  const userCredits = useAppSelector(selectUserAvailableCredits);

  return (
    <div className="sticky top-[50px] mt-[50px] h-fit place-items-center rounded-[10px] bg-flexi-white-1 p-[30px] sm:p-[45px] lg:mt-[100px] lg:min-w-[420px] lg:w-auto lg:p-[60px]">
      <h5 className="col-span-2 mb-[40px] text-center text-[24px] font-bold sm:text-[26px]">
        Booking Summary
      </h5>
      <ul className="flex flex-col gap-[20px] text-[16px] w-full">
        <li className="flex flex-col gap-[8px]">
          <div className="flex items-center justify-between gap-4 border-b-[1px] border-dotted border-flexi-black-6 pb-[.5px] text-sm">
            <small className="block text-[16px]">Estimated Cost</small>
            <span className="text-[16px]">
              ${breakdowns?.estimateTotal.toFixed(2)}
            </span>
          </div>
          <ul className="flex flex-col gap-[8px] pl-[24px] text-[14px]">
            <li className="flex items-center justify-between">
              <span>Booking Charges</span>
              <span>${breakdowns?.timeTotal.toFixed(2)}</span>
            </li>
            {breakdowns && breakdowns.podFeesTotal > 0 && (
              <li className="flex items-center justify-between">
                <span>Premium Location Fee</span>
                <span>${breakdowns.podFeesTotal.toFixed(2)}</span>
              </li>
            )}
            <li className="flex items-center justify-between">
              <span className="text-[14px]">Km Charges</span>
              {breakdowns && breakdowns.distanceTotal > 0 ? (
                <span>${breakdowns.distanceTotal.toFixed(2)}</span>
              ) : (
                <span className="text-[10px]">Calculated on Return</span>
              )}
            </li>
            {breakdowns?.addons && breakdowns.addons.length > 0 && (
              <li className="flex items-center justify-between">
                <span>Damage Reduction</span>
                <span>
                  $
                  {breakdowns.addons
                    .reduce((sum, a) => sum + a.value, 0)
                    .toFixed(2)}
                </span>
              </li>
            )}
          </ul>
        </li>
        {bookingPromo && (
          <li className="flex items-center justify-between gap-4 border-b-[1px] border-dotted border-flexi-black-6 pb-[.5px] text-sm">
            <div>
              <p className="block text-[16px]">Promotions</p>
              <p className="text-[12px] font-bold">{breakdowns?.promo?.name}</p>
            </div>
            <span className="text-[16px]">
              -${breakdowns?.promo?.actualValue.toFixed(2)}
            </span>
          </li>
        )}
        <li className="flex items-center justify-between gap-4 border-b-[1px] border-dotted border-flexi-black-6 pb-[.5px] text-sm">
          <small className="block text-[16px]">Total Charges</small>
          <span className="text-[16px]">
            ${breakdowns?.total?.toFixed(2)}
          </span>
        </li>
        {toggleUseCredits &&
          userCredits?.availableCredits && userCredits?.availableCredits > 0 ? (
            <li className="flex items-center justify-between gap-4 border-b-[1px] border-dotted border-flexi-black-6 pb-[.5px] text-sm">
              <small className="block text-[16px]">Credits</small>
              <span className="text-[16px]">
                -$
                {toggleUseCredits && breakdowns?.total
                  ? userCredits &&
                    userCredits?.availableCredits < breakdowns?.total
                    ? userCredits?.availableCredits.toFixed(2)
                    : breakdowns?.total.toFixed(2)
                  : (0).toFixed(2)}
              </span>
            </li>
          ): <></>}
      </ul>
      <div className="mt-[20px] flex justify-between gap-4 w-full">
        <div>
          <p className="text-[20px] font-bold sm:text-[22px]">Total Owing</p>
          <p className="text-[10px]">GST Included</p>
        </div>
        <p className="self-center text-[24px] font-bold sm:text-[26px]">
          ${toggleUseCredits && userCredits?.availableCredits && breakdowns?.total
            ? (breakdowns.total - Math.min(userCredits.availableCredits, breakdowns.total)).toFixed(2)
            : breakdowns?.total?.toFixed(2)}
        </p>
      </div>
    </div>
  );
};

export default SummaryInvoice;
